import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload } from "@fortawesome/free-solid-svg-icons"
import { ActionLink } from "../../ui/PageHeader"

/** Filter to download a csv file based on supplied filters */
const DownloadCSVLink = ({ filter = {}, displayCount, generateURL }) => {
  const csvURL = generateURL(filter)
  if (displayCount === 0) {
    return null
  }
  return (
    <ActionLink
      href={csvURL}
      title="Download observations matching the current filter as a CSV file"
    >
      <span>
        {displayCount != null && displayCount.toLocaleString()} as CSV{" "}
      </span>
      <FontAwesomeIcon icon={faDownload} />
    </ActionLink>
  )
}
DownloadCSVLink.propTypes = {
  filter: PropTypes.object,
  generateURL: PropTypes.func.isRequired,
  displayCount: PropTypes.number,
}
export default DownloadCSVLink
